<div class="innerBanner" style="background-image: url('{{ bannerImage }}')" (click)="imageClick(0)">
  <!-- inner banner-->
  <div class="bannerText">
    <h1>{{ islandsBannerAndContent.bannerTitle }}</h1>
  </div>
</div>

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
</p-galleria>

<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="/home">Home</a></li>
    <li class="breadcrumb-item active" aria-current="page">{{ islandsBannerAndContent.bannerTitle }}</li>
  </ol>
</nav>
<div *ngIf="islandsAccom" class="p-grid m-0">
  <div *ngFor="let island of islandsAccom; let index = index" class="p-col-10 islandsAllSection" key="index">
    <a (click)="islands(island.view_node)"
      ><img [src]="island.uri ? island.uri : '../../../assets/images/NoImage.jpg'" style="cursor: pointer"
    /></a>
    <div class="title">
      <small>{{ island.title }}</small>
    </div>
  </div>
</div>
<div *ngIf="islandsGroups" class="p-grid m-0">
  <div *ngFor="let island of islandsGroups; let index = index" class="p-col-10 islandsAllSection" key="index">
    <a (click)="islandGroups(island)"
      ><img [src]="island.uri ? island.uri : '../../../assets/images/NoImage.jpg'" style="cursor: pointer"
    /></a>
    <div class="title">
      <small>{{ island.name }}</small>
    </div>
  </div>
</div>
